@let _table = table();

@if (visible() && _table != null) {
    <interacta-dialog
        [isOpen]="true"
        [size]="'fit-content'"
        [testId]="'table-info-dialog'"
        (closing)="close()"
    >
        <h2 class="line-clamp-3 typo-t6 break-all" title>
            {{ _table.title }}
        </h2>

        <div class="flex flex-col space-y-16 typo-medium" content>
            <interacta-editable-table
                [ngModel]="_table.data"
                [readonly]="true"
            />
        </div>
    </interacta-dialog>
}
